(function (angular, $, window) {
    'use strict';
    // window.THF.Angular.LiveQuoteTool.animation('.cover-options', [function() {
    //     var originalHeight;
    //
    //     return {
    //         addClass: function(element, className, doneFn) {
    //             if( className == 'ng-hide' ) {
    //                 // $(element).css({overflow: 'hidden'}).animate({height: '0'}, 100, function () {
    //                 //     $(this).css({overflow: ''});
    //                 //     doneFn();
    //                 // });
    //             }
    //         },
    //         removeClass: function(element, className, doneFn) {
    //             // if( className == 'ng-hide' ) {
    //             //     // Get the height.
    //             //     if( typeof originalHeight === 'undefined' ) {
    //             //         $(element).show();
    //             //         originalHeight = $(element).outerHeight();
    //             //         $(element).hide();
    //             //     }
    //             //     $(element).css({
    //             //         display: 'block',
    //             //         height: 0
    //             //     }).animate({height: originalHeight}, 100, function () {
    //             //         $(element).css({
    //             //             overflow: 'none'
    //             //         });
    //             //         doneFn();
    //             //     });
    //             // }
    //         }
    //     }
    // }]);


})(angular, jQuery, window);
